export default __webpack_public_path__ + "static/media/plain-sticker-3.92f999e2.png";